export const BAR_HEIGHT = 80
export const MENU_TRANSITION_DURATION = 300
export const Z_INDEX = 550

export const LOGO_ELEMENT_ID = 'super-app-navigation-bar-logo'

export const TRANSLUCENT_ROUTES = ['/job-search']
